import Close from '@monofront/design-system/visuals/Icons/Old/Close';
import Button from '@monofront/design-system/components/Button';
import { useTranslations } from 'next-intl';

interface ISideCartHeaderProps {
  children: React.ReactNode;
  onClose: () => void;
}

const SideCartHeader: React.FC<ISideCartHeaderProps> = ({
  children,
  onClose,
}) => {
  const tGlobal = useTranslations('Global');

  return (
    <>
      <header className="header desktop-only !tw-m-0">
        <div className="title-container">{children}</div>

        <Button
          variant="clear"
          className="close-icon tw-translate-y-0.5"
          onClick={onClose}
          ariaLabel={tGlobal('close')}
        >
          <Close width={12} height={12} aria-hidden />
        </Button>
      </header>

      <style jsx>{`
        .header {
          padding: var(--space-4);
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: var(--white);
          border-bottom: 1px solid var(--clr-tertiary-2);
          z-index: var(--zindex-fixed);
          height: 64px;
        }

        .title-container {
          display: flex;
          align-items: center;
        }

        .close-icon {
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default SideCartHeader;
